import { api } from '../../base';

export const fetchTableData = (
    url: string,
    queryParams: Record<string, string>
) => {
    return api.get({
        url: url,
        queryParams: queryParams, //{ ordering: '-id', page: '1', status: 'PUBLISHED' },
    });
};
